import { useMutation } from '@tanstack/react-query';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { ERROR_DEFAULT } from 'src/messages/assets';
import useProjectSystem from '../systems/useProjectSystem';

type RequestRoleUpgradeParams = {
  projectID: number;
};

const useRequestUpgradeRoleMutation = () => {
	const system = useProjectSystem();
	const snackbarSystem = useSnackbarSystem();

	return useMutation( {
		mutationFn: ( params: RequestRoleUpgradeParams ) => system.requestRoleUpgrade( params ),
		onSuccess: ( ) => {
			snackbarSystem.showSuccessMessage( { title: 'An email request was sent to the owner.' } );
		},
		onError: ( ) => {
			snackbarSystem.showErrorMessage( { title: ERROR_DEFAULT } );
		}
	} );
};

export default useRequestUpgradeRoleMutation;
